import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./styles.css";
import { onClick, onChange, onBlur } from "./controller";

const SecondQuestionComponent = ({
  onChangeInfoPatient,
  callApiValidator,
  infoPatient,
  setInfoPatient,
}) => {
  const [countryPrefix, setCountryPrefix] = useState("");
  const [errors, setErrors] = useState({
    fullName: false,
    phoneNumber: false,
  });

  return (
    <div>
      <h3 className="questionAppointment">Datos de registro</h3>
      <div className="inputForm">
        <div className="inputAndLabel">
          <p className="infoLabel">
            Nombre y apellidos<span className="asterisk"> *</span>
          </p>
          <input
            type="text"
            className={`inputField ${errors.fullName ? "error" : ""}`}
            name="name"
            value={infoPatient.name}
            onChange={(event) =>
              onChange(
                event,
                infoPatient,
                setInfoPatient,
                setErrors,
                onChangeInfoPatient
              )
            }
            style={{
              borderColor: errors.fullName ? "red" : "none",
              backgroundColor: errors.fullName ? "#f9c7c7" : "none",
            }}
          />
        </div>
        <div className="inputAndLabel">
          <p className="infoLabel">
            Teléfono móvil<span className="asterisk"> *</span>
          </p>
          <div className="phoneInputContainer">
            <PhoneInput
              country={"es"}
              value={infoPatient.phoneNumber}
              onBlur={(e, countryData) =>
                onBlur(
                  e,
                  "phoneNumber",
                  countryData,
                  setCountryPrefix,
                  infoPatient,
                  setInfoPatient,
                  setErrors,
                  onChangeInfoPatient
                )
              }
              placeholder=""
              inputStyle={{
                borderColor: errors.phoneNumber ? "rgb(255, 55, 0)" : "none",
                backgroundColor: errors.phoneNumber ? "#f9c7c7" : "none",
              }}
              inputClass={`inputFieldPhone ${
                errors.phoneNumber ? "error" : ""
              }`}
              containerClass={`inputFieldPhone ${
                errors.phoneNumber ? "error" : ""
              }`}
              inputProps={{
                autoComplete: "off",
                onPaste: (e) => e.preventDefault(),
              }}
            />
          </div>
        </div>
        <div className="inputAndLabel">
          <p className="infoLabel">N.I.F.</p>
          <input
            type="text"
            className="inputField"
            name="nif"
            value={infoPatient.nif}
            onChange={(event) =>
              onChange(
                event,
                infoPatient,
                setInfoPatient,
                setErrors,
                onChangeInfoPatient
              )
            }
          />
        </div>
        <div className="inputAndLabel">
          <p className="infoLabel">Email</p>
          <input
            type="email"
            className="inputField"
            name="email"
            value={infoPatient.email}
            onChange={(event) =>
              onChange(
                event,
                infoPatient,
                setInfoPatient,
                setErrors,
                onChangeInfoPatient
              )
            }
          />
        </div>
      </div>
      <div className="btnContainer">
        <button
          className="btnContinuar"
          onClick={() =>
            onClick(infoPatient, countryPrefix, setErrors, callApiValidator)
          }
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default SecondQuestionComponent;
